// Font files to load for PDF generation
const fontFiles = {
  "Roboto-Regular.ttf": () => import("./Roboto-Regular.ttf?url"),
  "Roboto-Medium.ttf": () => import("./Roboto-Medium.ttf?url"),
  "Roboto-Italic.ttf": () => import("./Roboto-Italic.ttf?url"),
  "Roboto-MediumItalic.ttf": () => import("./Roboto-MediumItalic.ttf?url"),
  "RobotoMono-Bold.ttf": () => import("./RobotoMono-Bold.ttf?url"),
  "RobotoMono-Regular.ttf": () => import("./RobotoMono-Regular.ttf?url"),
};

async function fetchFontAsBase64(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // Remove the data URL prefix to get just the base64
      const base64 = reader.result.split(",")[1];
      resolve(base64);
    };
    reader.readAsDataURL(blob);
  });
}

export default async () => {
  const output = {};
  const fontNames = Object.keys(fontFiles);

  const loadedFonts = await Promise.all(
    fontNames.map(async (fontName) => {
      const module = await fontFiles[fontName]();
      const base64 = await fetchFontAsBase64(module.default);
      return base64;
    })
  );

  fontNames.forEach((font, i) => (output[font] = loadedFonts[i]));
  return output;
};
